import { render, staticRenderFns } from "./NoDataAvailable.vue?vue&type=template&id=85b0d9fc&"
import script from "./NoDataAvailable.vue?vue&type=script&lang=js&"
export * from "./NoDataAvailable.vue?vue&type=script&lang=js&"
import style0 from "./NoDataAvailable.vue?vue&type=style&index=0&id=85b0d9fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports